export const drChecklistDraftSchema = {
	schema: {
		title: 'DR checklist draft schema',
		description: 'Unsaved Generated DR checklist answers per site and surface',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			site_id: {
				type: 'string',
			},
			surface_code: {
				type: 'string',
			},
			general_json: {
				type: 'string',
			},
			updated_at: {
				type: 'string',
				format: 'date-time',
			},
		},
		required: ['id', 'site_id', 'surface_code', 'general_json', 'updated_at'],
	},
};
